import React, { useMemo } from "react";
import { Table, Columns } from "components/table";
import Icon from "components/icon";
import { useAppTranslation } from "locale/useAppTranslation";
import { dateFormatter } from "_helper/timeFormatter";

export interface DriverDocumentRow {
    id: string;
    type: string;
    file_url: string;
    created_at?: string;
    expiry_date?: string;
}

interface DriverDocumentTableProps {
    documents: DriverDocumentRow[];
}

const DriverDocumentTable: React.FC<DriverDocumentTableProps> = ({ documents }) => {
    const { t } = useAppTranslation("driver");

    const columns: Columns<DriverDocumentRow>[] = useMemo(
        () => [
            {
                id: "no",
                fieldId: "index" as keyof DriverDocumentRow,
                label: t("col-no") || "No.",
                width: "60px",
                dragDisabled: true,
            },
            {
                id: "document-name",
                fieldId: "type",
                label: t("col-document-name") || "Document Name",
                dragDisabled: true,
            },
            {
                id: "expiry-date",
                fieldId: "expiry_date",
                label: t("col-expiry-date") || "Expiry Date",
                render: (row) => (
                    <span>{dateFormatter(row.expiry_date)}</span>
                ),
                dragDisabled: true,
            },
            {
                id: "file",
                fieldId: "file_url",
                label: t("col-file") || "File",
                render: (row) =>
                    row.file_url ? (
                        <a
                            href={row.file_url}
                            target="_blank"
                            rel="noreferrer"
                            className="font-medium text-primary-600 underline transition-colors hover:text-primary-700"
                        >
                            {t("btn-open-file") || "Open File"}
                        </a>
                    ) : (
                        <span className="text-text-tertiary">—</span>
                    ),
                dragDisabled: true,
            },
        ],
        [t]
    );

    return (
        <Table
            columns={columns}
            data={documents}
            rowKey="id"
            currentPage={1}
            limit={10}
            emptyIcon={<Icon name="uo-empty" width={80} height={63} />}
            emptyTitle={t("empty-title") || "No Data added yet"}
            emptyDescription={t("empty-document-list-description") || "There is no documents for this driver"}
            enableColumnDrag={false}
            enableColumnResize={false}
        />
    );
};

export default DriverDocumentTable;
